import { Chakra } from "@airhelp/react-ui-components";
import { useTranslations, useLanguage } from "contexts/LocalizationContext";
import MontrealAnimatedFlag from "./MontrealAnimatedFlag/MontrealAnimatedFlag";
import SingleFlag from "./SingleFlag/SingleFlag";
import FlagText from "./FlagText/FlagText";
import { useFlags } from "./hooks";

const { Flex, SimpleGrid } = Chakra;

const Flags = () => {
  const translations = useTranslations();
  const language = useLanguage();
  const flags = useFlags(language);

  return (
    <SimpleGrid
      gridColumn={{ base: "span 1", md: "span 12" }}
      bg="white"
      rounded="sm"
      columns={{ base: 1, md: 4 }}
      spacing={{ base: 3, md: 10 }}
      boxShadow="alt"
      py={{ base: 6, md: 10 }}
      px={8}
      zIndex="0"
      mb={6}
    >
      <Flex
        textTransform="uppercase"
        fontWeight="bold"
        fontSize="sm"
        align="center"
        textAlign="left"
        data-testid="flag-bar-text"
        pb={{ base: 4, md: 0 }}
      >
        {translations("airhelp_protects_rights")}
      </Flex>
      {flags.map(({ text, flag }) => (
        <Flex align="center" key={text}>
          <SingleFlag flag={flag} />
          <FlagText text={translations(text)} />
        </Flex>
      ))}
      <MontrealAnimatedFlag />
    </SimpleGrid>
  );
};

export default Flags;
